var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.391,
    height: 40.268,
    viewBox: "0 0 36.391 40.268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-text-svgrepo-com",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7078",
    "data-name": "Path 7078",
    d: "M3,17.507C3,10.2,3,6.542,5.271,4.271S11.2,2,18.507,2h3.877c7.31,0,10.965,0,13.236,2.271s2.271,5.926,2.271,13.236v7.754c0,7.31,0,10.965-2.271,13.236s-5.926,2.271-13.236,2.271H18.507c-7.31,0-10.965,0-13.236-2.271S3,32.571,3,25.261Z",
    transform: "translate(-3 -2)",
    fill: "none",
    stroke: "#e3871c",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7079",
    "data-name": "Path 7079",
    d: "M8,12H23.507",
    transform: "translate(1.692 7.384)",
    fill: "none",
    stroke: "#e3871c",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7080",
    "data-name": "Path 7080",
    d: "M8,8H23.507",
    transform: "translate(1.692 3.63)",
    fill: "none",
    stroke: "#e3871c",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7081",
    "data-name": "Path 7081",
    d: "M8,16h9.692",
    transform: "translate(1.692 11.137)",
    fill: "none",
    stroke: "#e3871c",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.b5dcc33e3a14ecc3b748a9b9ef08096b.svg";
export { ForwardRef as ReactComponent };